<template>
  <div
    class="color-picker__button"
    @click="$emit('click')"
  >
    <base-icon :icon="icon" />
    <slot>{{ label }}</slot>
  </div>
</template>

<script>
export default {
  name: 'ColorPickerButton',
  props: {
    icon: {
      type: String,
      default: 'check',
    },
    label: {
      type: String,
      default: 'Apply',
    },
  },
};
</script>

<style lang="scss" scoped>
.color-picker__button{
    display: grid;
    grid-template-columns: 14px auto;
    column-gap: 10px;
    align-items:center;
    cursor: pointer;
    height: 34px;
    font-family: $font-family-sans-serif-light;
    font-size: 0.75rem;
    &:hover{
        background-color: $gray-light-3;
    }

    & + & {
        margin-top: 5px;
    }
}
</style>
